module.exports = __webpack_public_path__ + "assets/loop-delete-list.9a42c824.svg";